const config = {
  apiUrl: "https://fxapi.dianleida.net",
  devApiUrl: "http://192.168.1.197:8080",
  // devApiUrl: "http://192.168.1.35:8080",
  // apiUrl: "https://47.92.31.107:20080",
  // devApiUrl: "https://112.5.156.98:20080",
  defToken:
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMSIsImF1dGhvcml6YXRpb25TaG9wSWQiOiIiLCJleHAiOjE3NTM3NTY4NTAsImlhdCI6MTc1MzY3MDQ1MH0.aXU0k0IbMpB1_sZewBo_ISWXLBINb_0rO60UabgVhK8",
  buyUrl:
    "https://pc.1688.com/product/detail.htm?spm=a260s.11177607.jcrmedqi.1.5946646bBVlfQz&productCode=3W8JVYuVoyeTgyhQQq9ruWQb%2BVuZQ4z3ZsVnW3laFMM%3D&productType=GROUP&keywords=11", //购买地址
  DOMAIN: "http://192.168.1.14:9091/",
  meituUrl: "https://fxmt.dianleida.net:20443/",
};
export default config;
